// extracted by mini-css-extract-plugin
export default {"container":"RecipeList_container__bRGRe","noRecipesFound":"RecipeList_noRecipesFound__wtKqq"};